module.exports = __webpack_public_path__ + "img/icon_option_set_2.fb91a5c8.svg";